import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

/**
 * OAuth Callback Page
 *
 * This page handles the redirect after Google OAuth authentication.
 * BetterAuth sets the session cookie automatically, so we just need to
 * invalidate the session query and redirect to the dashboard.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    const error = searchParams.get("error");

    if (error) {
      // Redirect to login with error
      navigate(`/login?error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }

    // Invalidate session cache to fetch the new session
    queryClient.invalidateQueries({ queryKey: ["session"] });

    // Redirect to dashboard
    navigate("/dashboard", { replace: true });
  }, [navigate, searchParams, queryClient]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-br from-kitchen-warm to-white">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600"></div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}
